import store from '@/store';
import client from './apiAmbassadorConnector';
import utils from './../common/utils';

export default {
  formatSheets(sheets) {
    return sheets
      .map((it) => {
        if (!it.source_identifier || !it.source_identifier.length) {
          // eslint-disable-next-line no-param-reassign
          it.source_identifier = it.reference_externe;
        }
        return it;
      })
      .map(it => Object.assign({}, it, { first_url: it.medias ? it.medias[0] : null }))
      .map(it => Object.assign({}, it, { image_url: it.first_url ? it.first_url.url : 'http://savings.gov.pk/wp-content/plugins/ldd-directory-lite/public/images/noimage.png' }));
  },

  async getById(sheetId) {
    try {
      const sheetResponse = await client().get(`/sheets/${sheetId}`);
      return sheetResponse.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération de la fiche, veuillez réessayer.",
      });
      return null;
    }
  },

  async getSheetsByClientId(clientId) {
    try {
      const sheetsResponse = await client().get(`/clients/${clientId}/sheets`);
      sheetsResponse.data.data = this.formatSheets(sheetsResponse.data.data);
      return sheetsResponse.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération des fiches du client, veuillez réessayer.",
      });
      return utils.createEmptyListResponse();
    }
  },

  async search(params, orphans = undefined) {
    try {
      if (orphans !== undefined) {
        params.orphans = orphans;
      }
      const sheetsResponse = await client().post('/sheets/search', params);
      sheetsResponse.data.data = this.formatSheets(sheetsResponse.data.data);
      return sheetsResponse.data;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération des fiches, veuillez réessayer.",
      });
      return utils.createEmptyListResponse();
    }
  },

  async searchOrphans(params) {
    return this.search(params, true);
  },

  async searchNonOrphans(params) {
    return this.search(params, false);
  },

  async getTypes() {
    try {
      const typesResponse = await client().get('/sheets/bordereaux');
      const values = typesResponse.data.data.map((it) => { return { id: it, name: store.state.app.sheetCategories[it.toLowerCase()] || it }});
      return values;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de récupération des données',
        detail: "Une erreur s'est produite lors de la récupération des bordereaux, veuillez réessayer.",
      });
      return null;
    }
  },

  async affectToClient(sheet, clientId) {
    try {
      await client().post(`/clients/${clientId}/sheets/${sheet.id}`);
      return true;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: "Echec de l'association de la fiche",
        detail: "Une erreur s'est produite lors de l'association de la fiche, veuillez réessayer.",
      });
      return false;
    }
  },
  
  async unbindFromClient(sheet, clientId) {
    try {
      await client().delete(`/clients/${clientId}/sheets/${sheet.id}`);
      return true;
    } catch (e) {
      store.dispatch('errorHandler/throwError', {
        title: 'Echec de la désassociation de la fiche',
        detail: "Une erreur s'est produite lors de la désassociation de la fiche, veuillez réessayer.",
      });
      return false;
    }
  },
};
